
export const sFechaPublicacion = '2026-02-10T19:54:39.0703516-06:00';
export const sVersion = 'vf1.1.602101954';
            